import spinnerImgPurple from "@assets/images/sand-glass-purple.svg";
import spinnerImgGreen from "@assets/images/sand-glass.svg";
import { Dialog, Paper } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";

const useStyles = makeStyles(
  theme => ({
    root: {
      width: "420px",
      padding: "48px 24px 46px",
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      margin: "0 auto",
      borderRadius: "1.6rem",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)"
    },
    caption: {
      color: theme.palette.grey[900],
      marginBottom: "1.2rem"
    },
    subcaption: {
      color: "#FF2600"
    },
    spinnerContainer: {
      position: "relative",
      margin: "0 0 80px"
    },
    spinnerGreen: {
      position: "absolute",
      top: "0",
      left: "50%",
      transform: "translate(-50%, 0)",
      animation: `$spin 0.9s ease-in-out infinite alternate`
    },
    "@keyframes spin": {
      "0%": { transform: "translate(-50%, 0) rotate(0deg)" },
      "20%": { transform: "translate(-50%, 0) rotate(0deg)" },
      "80%": { transform: "translate(-50%, 0) rotate(180deg)" },
      "100%": { transform: "translate(-50%, 0) rotate(180deg)" }
    },
    spinnerPurple: {
      position: "absolute",
      top: "0",
      left: "50%",
      transform: "translate(-50%, 0)",
      animation: `$spinFade 0.9s ease-in-out infinite alternate`
    },
    "@keyframes spinFade": {
      "0%": { transform: "translate(-50%, 0) rotate(180deg)", opacity: 0 },
      "20%": { transform: "translate(-50%, 0) rotate(180deg)", opacity: 0 },
      "80%": { transform: "translate(-50%, 0) rotate(360deg)", opacity: 1 },
      "100%": { transform: "translate(-50%, 0) rotate(360deg)", opacity: 1 }
    }
  }),
  { name: "SubmitOrder" }
);

interface DialogSubmitOrderProps {
  open: boolean;
  onClose?: () => void;
  title?: string;
  description?: string | JSX.Element;
}

const DialogProcessing: React.FC<DialogSubmitOrderProps> = ({
  open,
  onClose,
  title = "The system is processing...",
  description = "ระบบกำลังประมวลผลคำสั่งซื้อ กรุณารอสักครู่"
}) => {
  const classes = useStyles();
  // const customProcessTxt= "The system is processing..."
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: { borderRadius: 16 }
      }}
    >
      <Paper className={classes.root}>
        <div className={classes.spinnerContainer}>
          <img
            src={spinnerImgGreen}
            className={classes.spinnerGreen}
            alt="E-Ordering"
          />
          <img
            src={spinnerImgPurple}
            className={classes.spinnerPurple}
            alt="E-Ordering"
          />
        </div>
        <MyTypography variant="h6" className={classes.caption}>
          {title}
        </MyTypography>
        <MyTypography variant="body2">{description}</MyTypography>
      </Paper>
    </Dialog>
  );
};

export default DialogProcessing;
